import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, map } from 'rxjs';

import { environment } from '@env/environment';
import { BaseService } from './base.service';
import { EthanAbilitiesAngularSdk } from '@termsheetai/ethan-abilities-angular-sdk';

type AbilityResult = { output: string };

const API_KEY = environment.ethanAbilities.apiKey;

@Injectable({
  providedIn: 'root',
})
export class EthanAIAbilitiesService extends BaseService {
  constructor(
    protected readonly httpClient: HttpClient,
    private ethanServiceSDK: EthanAbilitiesAngularSdk,
  ) {
    super(httpClient);
    ethanServiceSDK.setApiKey(API_KEY);
  }

  useCalcCodeAbility(inputs: Record<string, any>): Observable<AbilityResult> {
    return this.ethanServiceSDK.useEthanAbility('calc_code', inputs) as Observable<AbilityResult>;
  }

  useParseOMAbility(inputs: Record<string, any>): Observable<any> {
    return this.ethanServiceSDK.useEthanAbility('parse_om', inputs);
  }

  extractDataFromDocumentAbility(inputs: Record<string, any>): Observable<any> {
    return this.ethanServiceSDK.useEthanAbility('parse_generic_pdf', inputs);
  }
}
